export default __webpack_public_path__ + "static/app-data-deletion-88f15ce5853ea0d36c1e073441cb4a4e.jpg";